<script>
/**
 * 排出事業者データ補完
 * 排出事業者選択画面
 */
import {mapActions, mapState} from "vuex";
import PrefectureList from '../../../../mixins/PrefectureList'
import Confirm from "../../../../components/Confirm.vue";
/**
 * 排出事業者データ補完
 * 排出事業者選択モーダル
 */
export default {
  name: "EmissionSearchModal",
  components: {Confirm},
  mixins: [PrefectureList],
  props: {
    /**
     * 本ダイアログ表示制御
     */
    dialog: {
      type: Boolean,
      default: false
    },
    /**
     * 対象マニフェスト
     */
    targetItem: {
      type: Object,
      default: () => null,
    },
    notExistSameNumber: {
      type: Boolean,
      default: false
    },
    /**
     * JWNETマニフェスト一覧で選択されたマニフェストID
     */
    targetSelectableIds: {
      type: Array,
      default: () => [],
    },
    /**
     * JWNETマニフェスト一覧検索結果表示日時
     */
    searchedAt: {
      type: Number,
      default: () => null,
    },
  },
  data() {
    return {
      /* 検索ブロック表示制御 */
      panel: null,
      /* ページ番号 */
      page: 1,
      /* paginationの最大数 */
      totalVisible: 7,
      /* 選択した排出事業者 */
      selectedItem: null,
      /* 選択行が持つオブジェクト */
      selectedRow: null,
      /* 同じ加入者番号の排出事業者にも紐付けする */
      withSelected: false,
      /* 一覧ヘッダー */
      tableHeaders: [],
      /* 排出事業者一覧情報 */
      emissions: [],
      /* ページング情報 */
      pagination: {
        current_page: 1,
        total_count: 0
      },
      /* 検索フォーム情報 */
      searchForm: {
        code: null,
        name: null,
        join_not_edi: false,
        zip_code: null,
        prefecture_code: null,
        address: null,
        phone_number: null,
        manifest_type: null,
      },
      /* マニフェスト区分 */
      manifestTypes: [
        { value: 'dxe_form', text: '電子マニフェスト(EDI)'},
        { value: 'other_form', text: '電子マニフェスト(WEB)'},
        { value: 'paper_form', text: '紙マニフェスト'}
      ],
    }
  },
  watch: {
    dialog(val) {
      Object.assign(this.$data.searchForm, this.$options.data().searchForm);
      Object.assign(this.$data.pagination, this.$options.data().pagination);
      this.emissions = [];
      this.withSelected = false;
      this.scrollToTop();
      this.unSelectRow();
      this.searchForm.join_not_edi = this.notExistSameNumber;
      if (val) {
        this.buildTableHeader();
        this.searchEmissions();
      }
    },
  },
  computed: {
    ...mapState('DriverTenantConfiguration', {
      enableBilling: 'use_billing',
    }),
  },
  methods: {
    ...mapActions("DriverTransferEmission", {
      fetchEmissions: "index",
      updateTransferManifest: "update",
    }),
    ...mapActions('DriverMasterEmission', {
      fetchEmission: 'show',
    }),
    /**
     * 検索ボタン クリックイベント
     */
    searchButtonClickEvent () {
      this.page = 1;
      this.unSelectRow();
      this.searchEmissions();
    },
    /**
     * ページ チェンジイベント
     */
    pageChangeEvent () {
      this.unSelectRow();
      this.searchEmissions();
    },
    /**
     * 一覧行 クリックイベント
     * @param item
     * @param row
     */
    rowClickEvent(item, row) {
      this.selectedItem = item;
      this.selectedRow = row;
      row.select(true);
    },
    /**
     * 閉じるボタン クリックイベント
     */
    closeButtonClickEvent () {
      this.$emit('closeCallback')
    },
    /**
     * 登録ボタン クリックイベント
     */
    registerButtonClickEvent () {
      const modalOption = {
        title: '確認',
        message: '紐付けします。よろしいですか？',
        options: {width: 320, isCancelButton: true}
      }
      this.$refs.confirm.open(modalOption).then((confirm) => {
        this.$refs.confirm.close()
        if (confirm) {
          this.registerTransformManifest();
        }
      })
    },
    /**
     * テーブルヘッダ作成
     */
    buildTableHeader () {
      let table_headers = [
        { text: "事業者コード\r\n加入者番号", value: "emission_code", sortable: false, width: "10%" },
        { text: "排出事業者\r\n事業者メモ", value: "emission_name", sortable: false, width: "20%" },
        { text: 'マニフェスト区分', value: 'manifest_type', sortable: false, width: "15%" },
        { text: "住所", value: "emission_address", sortable: false, width: "25%" },
      ]
      if (this.enableBilling) {
        table_headers.push({ text: "請求先\r\n請求先メモ", value: "billings", sortable: false, width: "30%" })
      }
      this.tableHeaders = table_headers
    },
    /**
     * 一覧検索
     */
    searchEmissions () {
      const params = {
        page: this.page,
        subscriber_number: this.targetItem.jwnet_emission_subscriber_number,
        without_invisible: true,
        ...this.searchForm
      };
      this.fetchEmissions({params: params}).then((content) => {
        this.emissions = content.emissions;
        this.pagination = content.pagination;
      });
    },
    /**
     * 登録処理
     */
    registerTransformManifest () {
      const params = {
        emission_id: this.selectedItem.id,
        searched_at: this.searchedAt,
        jwnet_manifest_ids: this.withSelected ? this.targetSelectableIds : [],
      }
      this.updateTransferManifest({ id: this.targetItem.id, params: params }).then(() => {
        this.$emit("registerCallback");
      })

    },
    unSelectRow () {
      if (this.selectedRow) {
        this.selectedRow.select(false)
      }
      this.selectedItem = null
      this.selectedRow = null
    },
    scrollToTop () {
      const elements = document.getElementsByClassName('emissionSearchBody');
      if (!elements || !elements.length) {
        // 要素が取得できなかった場合は終了
        return;
      }
      elements[0].scrollTop = 0;
    },

  }
}
</script>

<template>
  <div>
    <v-dialog
      :value="dialog"
      width="1400"
      scrollable
      @click:outside="closeButtonClickEvent"
      @close="closeButtonClickEvent"
      @keydown.esc="closeButtonClickEvent"
    >
      <v-card>
        <v-toolbar
          dark
          flat
          color="primary"
        >
          <v-toolbar-title>
            排出事業者紐付け
          </v-toolbar-title>
          <v-spacer />
          <v-toolbar-items>
            <v-btn
              icon
              dark
              @click="closeButtonClickEvent"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-subtitle>
          <fieldset class="transfer-header pa-2 mt-2">
            <legend>JWNET排出事業者情報</legend>
            <v-row dense>
              <v-col cols="12" md="2">
                <h6>加入者番号</h6>
                <span>{{targetItem.jwnet_emission_subscriber_number}}</span>
              </v-col>
              <v-col cols="12" md="5">
                <h6>{{ targetItem.jwnet_emission_name }}</h6>
                <span>{{ targetItem.jwnet_emission_address }}</span>
              </v-col>
              <v-col cols="12" md="5">
                <h6>{{ targetItem.jwnet_location_name }}</h6>
                <span>{{ targetItem.jwnet_location_address }}</span>
              </v-col>
            </v-row>
          </fieldset>
        </v-card-subtitle>
        <v-card-text
          class="emissionSearchBody"
          style="height: 45vh"
        >
          <v-row>
            <v-col>
              <v-expansion-panels
                v-model="panel"
                accordion
              >
                <v-expansion-panel>
                  <v-expansion-panel-header
                    class="panel-header-color panel-selectable"
                  >
                    <strong>
                      <v-icon class="panel-header-color"> mdi-magnify </v-icon>
                      &nbsp;条件を指定して検索
                    </strong>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-card flat>
                      <v-card-text>
                        <v-row dense>
                          <v-col cols="12" md="3">
                            <v-text-field
                              v-model="searchForm.code"
                              dense
                              hide-details="auto"
                              label="事業者コード"
                              clearable
                              outlined
                              persistent-hint
                              persistent-placeholder
                              rounded
                              style="font-size: 80%"
                              @blur="searchButtonClickEvent"
                              @click:clear="() => { searchForm.code = null; searchButtonClickEvent(); }"
                            />
                          </v-col>
                          <v-col cols="12" md="3">
                            <v-text-field
                              v-model="searchForm.name"
                              dense
                              hide-details="auto"
                              label="事業者名"
                              clearable
                              outlined
                              persistent-hint
                              persistent-placeholder
                              rounded
                              style="font-size: 80%"
                              @blur="searchButtonClickEvent"
                              @click:clear="() => { searchForm.name = null; searchButtonClickEvent(); }"
                            />
                          </v-col>
                          <v-col cols="12" md="3">
                            <v-select
                              v-model="searchForm.manifest_type"
                              :items="manifestTypes"
                              dense
                              hide-details="auto"
                              label="マニフェスト区分"
                              clearable
                              outlined
                              persistent-placeholder
                              rounded
                              style="font-size: 80%"
                              @click:clear="() => { searchForm.manifest_type = null; searchButtonClickEvent(); }"
                              @change="searchButtonClickEvent"
                            />
                          </v-col>
                          <v-col cols="12" md="3">
                            <v-checkbox
                              v-model="searchForm.join_not_edi"
                              class="mt-2"
                              dense
                              persistent-hint
                              persistent-placeholder
                              hide-details="auto"
                              style="font-size: 80%"
                              @change="searchButtonClickEvent"
                            >
                              <template v-slot:label>
                                <small>加入者番号未登録を含める</small>
                              </template>
                            </v-checkbox>
                          </v-col>
                        </v-row>
                        <v-row dense>
                          <v-col cols="12" md="3">
                            <v-text-field
                              v-model="searchForm.zip_code"
                              dense
                              hide-details="auto"
                              label="郵便番号"
                              clearable
                              outlined
                              persistent-hint
                              persistent-placeholder
                              rounded
                              style="font-size: 80%"
                              @blur="searchButtonClickEvent"
                              @click:clear="() => { searchForm.zip_code = null; searchButtonClickEvent(); }"
                            />
                          </v-col>
                          <v-col cols="12" md="3">
                            <v-autocomplete
                              v-model="searchForm.prefecture_code"
                              :items="prefList"
                              clearable
                              dense
                              hide-details="auto"
                              label="都道府県"
                              outlined
                              persistent-placeholder
                              placeholder="例）東京都"
                              rounded
                              style="font-size: 80%"
                              @click:clear="() => { searchForm.prefecture_code = null; searchButtonClickEvent(); }"
                              @change="searchButtonClickEvent"
                            />
                          </v-col>
                          <v-col cols="12" md="3">
                            <v-text-field
                              v-model="searchForm.address"
                              dense
                              label="市区町村・町域・詳細住所"
                              hide-details="auto"
                              clearable
                              outlined
                              persistent-placeholder
                              placeholder="例）中央区日本橋兜町１－２－３○○ビル○階"
                              rounded
                              style="font-size: 80%"
                              @blur="searchButtonClickEvent"
                              @click:clear="() => { searchForm.address = null; searchButtonClickEvent(); }"
                            />
                          </v-col>
                          <v-col cols="12" md="3">
                            <v-text-field
                              v-model="searchForm.phone_number"
                              autocomplete="off"
                              dense
                              hint="電話番号を「-」ハイフン「( )」込みで入力します"
                              hide-details="auto"
                              label="電話番号"
                              clearable
                              outlined
                              persistent-placeholder
                              placeholder="例）000-0000-0000"
                              persistent-hint
                              rounded
                              style="font-size: 80%"
                              @blur="searchButtonClickEvent"
                              @click:clear="() => { searchForm.phone_number = null; searchButtonClickEvent(); }"
                            />
                          </v-col>
                        </v-row>
                      </v-card-text>
                      <v-divider />
                      <v-card-actions>
                        <v-spacer />
                        <v-btn color="primary" @click="searchButtonClickEvent">検索</v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </v-col>
          </v-row>

          <v-row dense>
            <v-col>
              <v-data-table
                :headers="tableHeaders"
                :items="emissions"
                :items-per-page="-1"
                disable-sort
                hide-default-footer
                single-select
                @click:row="rowClickEvent"
              >
                <template v-slot:[`item.emission_code`]="{ item }">
                  <div>{{ item.code }}&nbsp;</div>
                  <div>{{ item.subscriber_number }}&nbsp;</div>
                </template>
                <template v-slot:[`item.emission_name`]="{ item }">
                    <div
                      class="text-ellipsis text-sm-caption"
                      :title="item.name"
                      style="width: 180px;"
                    >{{ item.name }}
                    </div>
                  <div
                    class="text-ellipsis text-sm-caption"
                    :title="item.memo"
                    style="width: 180px;"
                  >
                    <small>{{ item.memo }}</small>&nbsp;
                  </div>
                </template>
                <template v-slot:[`item.emission_address`]="{ item }">
                  <div><small>〒{{ item.zip_code }}</small></div>
                  <div
                    class="text-ellipsis text-sm-caption"
                    :title="item.address"
                    style="width: 220px;"
                  >{{ item.address }}</div>
                </template>
                <template v-slot:[`item.billings`]="{ item }">
                  <div
                    class="text-ellipsis text-sm-caption"
                    :title="item.billing_name"
                    style="width: 200px;"
                  >{{ item.billing_name }}</div>
                  <div
                    class="text-ellipsis text-sm-caption"
                    :title="item.billing_memo"
                    style="width: 200px;"
                  >
                    <small>{{ item.billing_memo }}</small>
                  </div>
                </template>
                <template v-slot:[`item.manifest_type`]="{ item }">
                  <small>{{ item.manifest_type | manifest_type_to_label }}</small>
                </template>
              </v-data-table>
            </v-col>
          </v-row>

          <!-- ページャ -->
          <v-row class="mb-15">
            <v-col>
              <v-pagination
                v-model="page"
                :length="pagination.total_pages"
                :total-visible="totalVisible"
                circle
                prev-icon="mdi-menu-left"
                next-icon="mdi-menu-right"
                @input="pageChangeEvent"
              />
            </v-col>
          </v-row>
          <!-- /ページャ -->
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-spacer />
          <v-checkbox
            v-model="withSelected"
            label="同じ加入者番号の排出事業者のマニフェスト（紐付け未設定）にも紐付けする"
            class="mr-5"
            dense
            persistent-hint
            persistent-placeholder
            style="font-size: 80%"
          />
          <v-btn
            @click="closeButtonClickEvent"
          >
            閉じる
          </v-btn>
          <v-btn
            :disabled="selectedItem === null"
            color="primary"
            @click="registerButtonClickEvent"
          >
            登録
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <confirm ref="confirm" />

  </div>
</template>
